import { Mail, type LucideIcon } from "lucide-react";

export type SocialLink = {
  label: string;
  href: string;
  Icon: LucideIcon;
};

export const site = {
  /** Wordmark shown in the header & footer. */
  name: "alaa.ink",
  /** Author credited in each post's meta strip. */
  author: "علاء",
  tagline: "دفتر مفتوح للكتابة الهادئة",
  copyright: "جميع الحقوق محفوظة"
} as const;

export const contactLink: SocialLink = {
  label: "راسل علاء عبر Gmail",
  href: "https://mail.google.com/mail/?view=cm&fs=1&to=alaasyedcs%40gmail.com",
  Icon: Mail
};

export const socialLinks: SocialLink[] = [contactLink];
